function StateSelect({ value, onChange, isMushroom }) {
  const states =
    isMushroom
      ? ["Before", "During", "After", "Integration"]
      : ["Before", "During", "After"];

  return (
    <div className="StateSelect">
      <label>
        State
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">-- Select State --</option>
          {states.map((st) => (
            <option key={st} value={st}>
              {st}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default StateSelect;